<template>
  <div>
    <a-table :scroll="{ x: 1800 }" :pagination="pagination" :columns="columns" size="middle" :data-source="ticketList" :loading="loading" row-key="id" @change="handleTableChange">
      <span slot="customKey" slot-scope="text, record">
        <div v-if="record.type === 1 && record.isOverTime >= 6 && [0, 2].includes(record.status)" class="corner-bad" />
        <div v-if="record.type === 1 && record.isOverTime >= 6 &&record.status>=3" class="corner-bad-done" />
        <div v-if="record.type === 1 && record.isOverTime >= 4 && record.isOverTime < 6 && [0, 2].includes(record.status)" class="corner-middle" />
        <div v-if="record.type === 1 && record.isOverTime > 2 && record.isOverTime < 4 && [0, 2].includes(record.status)" class="corner" />
        <span>{{ record.id }}</span>
      </span>
      <span slot="name" slot-scope="text, record">
        <a class="custom-link" target="_blank" @click="toDetail(record.id)">{{ record.name }}</a>
      </span>
      <span slot="meta" slot-scope="text, record">
        <a class="custom-link" target="_blank" @click="toDetail(record.id)">{{ record.meta.desc }}</a>
      </span>
      <template slot="attach" slot-scope="text, record">
        <span v-if="record.meta.image.length > 0">
          <a-upload
            action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
            list-type="picture-card"
            :show-upload-list="{ showRemoveIcon: false }"
            :file-list="convertImageList(record.meta.image)"
            @preview="handlePreview($event,record.meta.image)"
          />
        </span>
        <span v-else>无附件</span>
        <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
          <img alt="example" style="width: 100%" :src="previewImage" />
        </a-modal>
      </template>
      <template slot="reply" slot-scope="text, record">
        <span v-if="record.reply[0].desc">
          <a class="custom-link">{{ record.reply[0].desc.replace(/!\[.*?\]\(https:\/\/devops\-resource\.cdfsunrise\.com\/other\/\w+\.png\)/g, '') }}</a>
        </span>
        <span v-else>--</span>
      </template>
      <span slot="urgency" slot-scope="text, record">
        <problem-urgency-edit :source-id="record.id" :source-value="record.urgency" />
      </span>
      <span slot="status" slot-scope="text, record">
        <a-tag :color="ticketStatus[record.status].color">{{ ticketStatus[record.status].label }}</a-tag>
      </span>
      <span slot="from" slot-scope="text, record">
        <a-tag v-if="record.from == 1">{{ '乐狐七鱼' }}</a-tag>
        <a-tag v-if="record.from == 2">{{ '香港企点' }}</a-tag>
        <a-tag v-if="record.from == 3" color="red">{{ '香港业务方' }}</a-tag>
      </span>
      <span slot="qiyuTicketStatus" slot-scope="text, record">
        <a-tag :color="qiyuTicketStatus[record.qiyuTicketStatus].color">{{ qiyuTicketStatus[record.qiyuTicketStatus].label }}</a-tag>
      </span>
      <template slot="domain" slot-scope="text, record">
        <span v-if="ticketDomain[record.domain]">
          <a-tag :color="ticketDomain[record.domain].color">{{ ticketDomain[record.domain].label }}</a-tag>
        </span>
        <span v-else>-</span>
      </template>
      <span slot="tags" slot-scope="text, record">
        <a-tag>{{ getTagTitle(record.tags) }}</a-tag>
      </span>
      <span slot="aiResult" slot-scope="text, record">
        <a-tag v-if="record.aiResult === 1">{{ "未给出" }}</a-tag>
        <a-tag v-if="record.aiResult === 2">{{ "一致" }}</a-tag>
        <a-tag v-if="record.aiResult === 3">{{ "不一致" }}</a-tag>
      </span>
      <span slot="isOverTime" slot-scope="text, record">
        {{ record.isOverTime + '小时' }}
      </span>
      <span slot="creator" slot-scope="text, record">
        {{ '客服' + record.creator }}
      </span>
      <template slot="level" slot-scope="text, record">
        <span v-if="ticketLevel[record.level]">
          <a-tag :color="ticketLevel[record.level].color">{{ ticketLevel[record.level].label }}</a-tag>
        </span>
        <span v-else>-</span>
      </template>
      <span slot="handler" slot-scope="text, record">
        {{ getUserById(record.handler) }}
      </span>
      <span slot="maintainer" slot-scope="text, record">
        {{ getUserListById(record.maintainer) }}
      </span>
      <span slot="reporter" slot-scope="text, record"><problem-user-edit :source-id="record.id" :source-value="record.reporter" item="reporter" /></span>
    </a-table>
    <ticket-drawer v-if="editVisible" :visible="editVisible" :ticket-id="ticketId" @close="close" />
  </div>
</template>
<script>
import { problemUrgencys, problemStatus, ticketStatus, problemChannels, ticketDomain, ticketLevel, ticektTag, qiyuTicketStatus } from '@/utils/dictionary';
import { userList } from '@/api/system/auth';
// import Lightbox from 'vue-pure-lightbox';
import TicketDrawer from '@/pages/event/components/TicketDrawer';
import 'viewerjs/dist/viewer.css';
import { api as viewerApi } from 'v-viewer';

function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}

export default {
  components: { TicketDrawer },
  props: {
    ticketList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    pagination: {
      type: Object,
      default: null
    },
    columns: {
      type: Array,
      default: () => {
        return [];
      }
    },
    ticketTagList: {
      type: Array,
      default: null
    }
  },
  data() {
    return {
      editVisible: false,
      previewVisible: false,
      previewImage: '',
      ticketId: 0,
      loading: false,
      expand: true,
      sourceId: null,
      problemId: null,
      problemStatus,
      ticketStatus,
      problemChannels,
      problemUrgencys,
      qiyuTicketStatus,
      ticketDomain,
      ticketLevel,
      ticektTag,
      userData: [],
      projects: [],
      filterForm: {
        pageSize: 20,
        pageNumber: 1,
        sortedBy: '',
        sortedMethod: ''
      },
      faultVisible: false,
      modalVisible: false,
      tableData: [],
      lightboxImages: [],
      currentImageIndex: 0,
      lightboxOptions: {
        // 配置项，例如：缩放、导航按钮等
      }
    };
  },
  computed: {
    getUser() {
      return user => {
        return user === null ? '--' : user.nickname;
      };
    }
  },
  mounted() {
    this.getUserList();
  },
  methods: {
    convertImageList(imageList) {
      return imageList.map((url, index) => ({
        uid: `-${index + 1}`,
        name: 'image.png',
        status: 'done',
        url: url
      }));
    },
    handleCancel() {
      this.previewVisible = false;
    },
    handlePreview(file, images) {
      // if (!file.url && !file.preview) {
      //   file.preview = await getBase64(file.originFileObj);
      // }
      // this.previewImage = file.url || file.preview;
      // this.previewVisible = true;
      let idx = 0;
      if (images && images.length > 0) {
        idx = images.indexOf(file.url);
      }
      viewerApi({
        options: {
          initialViewIndex: idx,
          title: false,
          navbar: images && images.length > 1,
          button: true,
          toolbar: (images && images.length > 1)
            ? {
              zoomIn: true,
              zoomOut: true,
              oneToOne: true,
              reset: true,
              prev: true,
              play: false,
              next: true,
              rotateLeft: false,
              rotateRight: false,
              flipHorizontal: false,
              flipVertical: false
            } : false
        },
        images: images
      });
    },
    // openLightbox(record, image) {
    //   this.lightboxImages = record.meta.image.map(item => ({ src: item }));
    //   this.currentImageIndex = record.meta.image.findIndex(item => item === image);
    //   this.$refs.lightbox.open();
    // },
    toDetail(ticketId) {
      this.ticketId = ticketId;
      this.editVisible = true;
    },
    close() {
      this.editVisible = false;
    },
    getTagTitle(key) {
      const node = this.findNodeByKey(this.ticketTagList, key);
      if (node) {
        return node.title;
      }
      return '';
    },
    findNodeByKey(tree, key) {
      for (const node of tree) {
        // eslint-disable-next-line eqeqeq
        if (node.key == key) {
          return node;
        }
        if (node.children) {
          const foundNode = this.findNodeByKey(node.children, key);
          if (foundNode) {
            return foundNode;
          }
        }
      }
      return null;
    },
    // 获取用户列表
    getUserList() {
      userList({}).then(res => {
        this.userData = res.data.users;
      });
    },
    getUserById(user_id) {
      const user = this.userData.find(item => item.fs_user_id === user_id);
      return user ? user.nickname : '-';
    },
    getUserListById(user_id_list) {
      if (!Array.isArray(user_id_list)) {
        console.error('user_id_list is not an array', user_id_list);
        return '-';
      }

      const user_name_list = user_id_list
        .map(userId => {
          const user = this.userData.find(item => item.fs_user_id === userId);
          return user ? user.nickname : null;
        })
        .filter(Boolean)
        .join(';');
      return user_name_list;
    },

    handleTableChange(pagination, _, sorter) {
      this.filterForm.pageSize = pagination.pageSize;
      this.filterForm.pageNumber = pagination.current;
      this.filterForm.sortedBy = sorter.field;
      this.filterForm.sortedMethod = sorter.order === 'ascend' ? 'asc' : 'desc';
      this.$emit('callback', this.filterForm);
    }
  }
};
</script>
<style lang="less" scoped>
/deep/ .customer-filter {
  .ant-page-header {
    padding: 0;
  }
  margin-bottom: 16px;
  .ant-form-item {
    margin-bottom: 8px;
    display: flex;
    .ant-form-item-control-wrapper {
      flex: 1;
    }
  }
  .filter-right {
    float: right;
    text-align: right;
  }
}
.custom-link {
  color: rgba(0, 0, 0, 0.65);
}
.custom-link:hover {
  color: #1890ff;
}
/deep/.is-fault.ant-tag {
  margin-right: 0;
}

.corner {
  position: relative;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.4), transparent) #ec374d;
}

.corner::before {
  position: absolute;
  top: -12px;
  left: -8px;
  font-size: 12px;
  height: 16px;
  content: '即将超时';
  border-radius: 2px 2px 2px 0px;
  padding: 2px 4px;
  line-height: 12px;
  color: #fff;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.4), transparent) #ec374d;
  background-blend-mode: soft-light;
}

.corner::after {
  position: absolute;
  content: '';
  clip-path: polygon(0 0, 4px 0, 4px 4px);
  width: 8px;
  height: 8px;
  left: -8px;
  bottom: -12px;
  /* 颜色变暗：filter滤镜、半透明遮罩 */
  /* 使用filter滤镜 使颜色变暗 */
  /*filter: brightness(.6);*/
  /* 给颜色上添加一个半透明遮罩实现颜色变暗 */
  background: linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3));
  background-color: inherit; /* 继承 */
}

.corner-bad {
  position: relative;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.4), transparent) #ec374d;
}

.corner-bad::before {
  position: absolute;
  top: -12px;
  left: -8px;
  font-size: 12px;
  height: 16px;
  content: '已严重超时';
  border-radius: 2px 2px 2px 0px;
  padding: 2px 4px;
  line-height: 12px;
  color: #fff;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.4), transparent) #ec374d;
  background-blend-mode: soft-light;
}

.corner-bad::after {
  position: absolute;
  content: '';
  clip-path: polygon(0 0, 4px 0, 4px 4px);
  width: 8px;
  height: 8px;
  left: -8px;
  bottom: -12px;
  background: linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3));
  background-color: inherit; /* 继承 */
}

.corner-middle {
  position: relative;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.4), transparent) #ec374d;
}

.corner-middle::before {
  position: absolute;
  top: -12px;
  left: -8px;
  font-size: 12px;
  height: 16px;
  content: '已超时';
  border-radius: 2px 2px 2px 0px;
  padding: 2px 4px;
  line-height: 12px;
  color: #fff;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.4), transparent) #ec374d;
  background-blend-mode: soft-light;
}

.corner-middle::after {
  position: absolute;
  content: '';
  clip-path: polygon(0 0, 4px 0, 4px 4px);
  width: 8px;
  height: 8px;
  left: -8px;
  bottom: -12px;
  background: linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3));
  background-color: inherit; /* 继承 */
}

.corner-bad-done {
  position: relative;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.4), transparent) #ec374d;
}
.corner-bad-done::before {
  position: absolute;
  top: -12px;
  left: -8px;
  font-size: 12px;
  height: 16px;
  content: '超时解决';
  border-radius: 2px 2px 2px 0px;
  padding: 2px 4px;
  line-height: 12px;
  color: #fff;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.4), transparent) #ec374d;
  background-blend-mode: soft-light;
}

.corner-bad-done::after {
  position: absolute;
  content: '';
  clip-path: polygon(0 0, 4px 0, 4px 4px);
  width: 8px;
  height: 8px;
  left: -8px;
  bottom: -12px;
  background: linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3));
  background-color: inherit; /* 继承 */
}

</style>
